import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import CancelTaxReceiptForm from 'src/components/Forms/CancelTaxReceiptForm';

const CancelTaxReceiptDialog = () => {
  const opened =
    useSelector((state: Store) => state.dialog[DIALOGS.cancelTaxReceipt]?.opened || false);

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="cancel-tax-receipt"
      open={opened}>
      <DialogTitle id="cancel-tax-receipt">{t(lang, 'menus.cancel_tax_receipt')}</DialogTitle>
      <DialogContent dividers>
        <CancelTaxReceiptForm />
      </DialogContent>
    </Dialog>
  );
};

export default CancelTaxReceiptDialog;
